import { TFunction } from "i18next";
import * as yup from "yup";

export function buildSeaPublishSchema(translate: TFunction): yup.AnyObjectSchema {
  return yup.object().shape({
    isSubscribed: yup.boolean(),
    shipmentType: yup
      .string()
      .required(translate("thisFieldIsRequired"))
      .typeError(translate("thisFieldIsRequired")),
    containerId: yup
      .string()
      .required(translate("thisFieldIsRequired"))
      .typeError(translate("thisFieldIsRequired")),
    loadType: yup
      .string()
      .required(translate("thisFieldIsRequired"))
      .typeError(translate("thisFieldIsRequired")),
    billOfLanding: yup.string().when("isSubscribed", {
      is: true,
      then: yup
        .string()
        .trim()
        .required(translate("thisFieldIsRequired"))
        .typeError(translate("thisFieldIsRequired")),
      otherwise: yup.string().notRequired().nullable(),
    }),
    jobs: yup
      .array()
      .of(yup.object().nullable())
      .when("isSubscribed", {
        is: true,
        then: yup
          .array()
          .of(yup.object().nullable())
          .test("jobs-or-customers-required", translate("thisFieldIsRequired"), function (value) {
            const { customers } = this.parent;
            const hasJobs = value && value.length > 0;
            const hasCustomers = customers && customers.length > 0;

            if (hasJobs || hasCustomers) return true;

            return false;
          }),
        otherwise: yup.array().notRequired().nullable(),
      }),
    customers: yup
      .array()
      .of(yup.object().nullable())
      .when("isSubscribed", {
        is: true,
        then: yup
          .array()
          .of(yup.object().nullable())
          .test("jobs-or-customers-required", translate("thisFieldIsRequired"), function (value) {
            const { jobs } = this.parent;
            const hasJobs = jobs && jobs.length > 0;
            const hasCustomers = value && value.length > 0;

            if (hasJobs || hasCustomers) return true;

            return false;
          }),
        otherwise: yup.array().notRequired().nullable(),
      }),
    containers: yup.array().when("isSubscribed", {
      is: true,
      then: yup
        .array()
        .min(1)
        .of(
          yup.object().shape({
            container: yup
              .string()
              .required(translate("thisFieldIsRequired"))
              .typeError(translate("thisFieldIsRequired")),
            size: yup.string().notRequired().nullable(),
            seal: yup.string().notRequired().nullable(),
            verifiedGrossWeight: yup.boolean().notRequired().nullable(),
            grossWeight: yup
              .number()
              .notRequired()
              .nullable()
              .test("is-required", translate("enterAValueGraterThanNetWeight"), function (value) {
                if (!value && !this.parent.netWeight) return true;

                if (
                  value !== undefined &&
                  value !== null &&
                  this.parent.netWeight !== undefined &&
                  value > this.parent.netWeight
                ) {
                  return true;
                }

                return false;
              }),
            netWeight: yup
              .number()
              .notRequired()
              .nullable()
              .test("is-required", translate("enterAValueLowerThanGrossWeight"), function (value) {
                if (!value && !this.parent.grossWeight) return true;

                if (
                  value !== undefined &&
                  value !== null &&
                  this.parent.grossWeight &&
                  value < this.parent.grossWeight
                ) {
                  return true;
                }

                return false;
              }),
            tareWeight: yup.number().notRequired().nullable(),
            volumetricWeight: yup.number().notRequired().nullable(),
          })
        )
        .test("is-required", translate("thisFieldIsRequired"), function (value) {
          if (value && value.length) return true;

          return false;
        }),
      otherwise: yup.array().notRequired().nullable(),
    }),
  });
}

export function buildAirPublishSchema(
  translate: TFunction,
  isMvCompany: boolean
): yup.AnyObjectSchema {
  return yup.object().shape({
    commodity: isMvCompany ? yup.string().required() : yup.string().notRequired(),
    isSubscribed: yup.boolean(),
    shipmentType: yup
      .string()
      .required(translate("thisFieldIsRequired"))
      .typeError(translate("thisFieldIsRequired")),
    jobs: yup
      .array()
      .of(yup.object().nullable())
      .when("isSubscribed", {
        is: true,
        then: yup
          .array()
          .of(yup.object().nullable())
          .test("jobs-or-customers-required", translate("thisFieldIsRequired"), function (value) {
            const { customers } = this.parent;
            const hasJobs = value && value.length > 0;
            const hasCustomers = customers && customers.length > 0;

            if (hasJobs || hasCustomers) return true;

            return false;
          }),
        otherwise: yup.array().notRequired().nullable(),
      }),
    customers: yup
      .array()
      .of(yup.object().nullable())
      .when("isSubscribed", {
        is: true,
        then: yup
          .array()
          .of(yup.object().nullable())
          .test("jobs-or-customers-required", translate("thisFieldIsRequired"), function (value) {
            const { jobs } = this.parent;
            const hasJobs = jobs && jobs.length > 0;
            const hasCustomers = value && value.length > 0;

            if (hasJobs || hasCustomers) return true;

            return false;
          }),
        otherwise: yup.array().notRequired().nullable(),
      }),
  });
}
